export enum SkeletonVariant {
  Table,
  Filter,
  Form,
  Card,
  CardGroup,
  List,
  Details,
  InfoList,
}

export type SkeletonProps = {
  variant: SkeletonVariant
}
